'use client'

import { AnimatePresence, motion } from 'motion/react'
import { useEffect, useState } from 'react'
import { useThemeMode } from '@/contexts/ThemeContext'

export default function CookieConsent() {
  const { colors } = useThemeMode()
  const [show, setShow] = useState(false)

  useEffect(() => {
    // Check if user has already consented
    const hasConsented = localStorage.getItem('cookie-consent')
    if (!hasConsented) {
      // Small delay before showing for better UX
      const timer = setTimeout(() => setShow(true), 1000)
      return () => clearTimeout(timer)
    }
  }, [])

  const handleAccept = () => {
    localStorage.setItem('cookie-consent', 'accepted')
    setShow(false)
  }

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: 20 }}
          transition={{ duration: 0.3 }}
          style={{
            position: 'fixed',
            bottom: '20px',
            right: '20px',
            maxWidth: '400px',
            width: 'calc(100% - 40px)',
            backgroundColor: colors.windowBg,
            border: `1px solid ${colors.windowBorder}`,
            borderRadius: '8px',
            padding: '16px 20px',
            boxShadow: '0 8px 24px rgba(0, 0, 0, 0.2)',
            backdropFilter: 'blur(10px)',
            zIndex: 9999,
          }}
        >
          <div
            style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}
          >
            <div style={{ display: 'flex', alignItems: 'start' }}>
              <div style={{ flex: 1 }}>
                <p
                  style={{
                    margin: 0,
                    fontSize: '13px',
                    lineHeight: '1.5',
                    color: colors.primaryText,
                  }}
                >
                  We use cookies to save your preferences (themes, settings, and
                  session data) for a better experience.
                </p>
              </div>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: '12px',
              }}
            >
              {/* Animated cookie marquee */}
              <div
                style={{
                  flex: 1,
                  overflow: 'hidden',
                  height: '24px',
                  position: 'relative',
                  maskImage:
                    'linear-gradient(to right, transparent, black 10%, black 90%, transparent)',
                  WebkitMaskImage:
                    'linear-gradient(to right, transparent, black 10%, black 90%, transparent)',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    animation: 'marquee 8s linear infinite',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {Array.from({ length: 20 }).map((_, i) => (
                    <span key={i} style={{ marginRight: '16px' }}>
                      🍪
                    </span>
                  ))}
                </div>
              </div>
              <button
                onClick={handleAccept}
                style={{
                  backgroundColor: colors.primaryAccent,
                  color: colors.darkText,
                  border: 'none',
                  borderRadius: '4px',
                  padding: '6px 16px',
                  fontSize: '13px',
                  fontWeight: 500,
                  cursor: 'pointer',
                  transition: 'opacity 0.2s',
                  flexShrink: 0,
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.opacity = '0.85'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.opacity = '1'
                }}
              >
                Got it
              </button>
            </div>
          </div>

          {/* Keyframe animations */}
          <style>
            {`
              @keyframes marquee {
                0% {
                  transform: translateX(0);
                }
                100% {
                  transform: translateX(-50%);
                }
              }
            `}
          </style>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
